import Markdown from '../../global/Markdown'

export const Subheading = (props: {
  children: any
  className?: string
  color?: string
  displaySubHeading?: boolean
  useNewFonts?: boolean
}) =>
  props.children && props.displaySubHeading ? (
    <div className={props.className} suppressHydrationWarning>
      <h2
        color={props.color}
        className={
          props.useNewFonts
            ? 'new-text-m-regular'
            : 'old-title-medium-serif-400'
        }
        style={{
          color: props.color && `var(--${props.color})`,
        }}
      >
        <Markdown input={props.children} />
      </h2>
    </div>
  ) : (
    <></>
  )
